// extracted by mini-css-extract-plugin
export var blogPagePanel = "Card-module--blogPagePanel--d0e4a";
export var body = "Card-module--body--3c06a";
export var desc = "Card-module--desc--73567";
export var descFooter = "Card-module--descFooter--36198";
export var heading = "Card-module--heading--6fa98";
export var icon = "Card-module--icon--7b030";
export var img = "Card-module--img--9e69a";
export var middleBody = "Card-module--middleBody--7b36e";
export var more = "Card-module--more--98c08";
export var panel = "Card-module--panel--952a3";
export var pearlHeading = "Card-module--pearlHeading--6441d";
export var rockHeading = "Card-module--rockHeading--9ad38";
export var skyFooter = "Card-module--skyFooter--a8548";
export var skyHeading = "Card-module--skyHeading--33768";
export var skyPanel = "Card-module--skyPanel--4042b";
export var subTitle = "Card-module--subTitle--061fc";
export var tideBody = "Card-module--tideBody--c2449";
export var tideFooter = "Card-module--tideFooter--4dd8f";
export var tidePanel = "Card-module--tidePanel--9f75c";
export var tileImage = "Card-module--tileImage--6d09b";
export var tileText = "Card-module--tileText--b8eb8";
export var whiteFooter = "Card-module--whiteFooter--2af6d";